module.exports = __webpack_public_path__ + "static/img/logo.3bfa555.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/logo.svg
// module id = merl
// module chunks = 1